<template>
  <div style="height: 100vh;" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div>
      <div>
        <div>
          <div :class="header == true ? 'block' : 'block1'" style="display: flex;justify-content: space-between;width: 100%;height:60px">
            <div id="form"  style="margin-top: 16px; margin-left: 11px;    display: flex; height: 30px;">
                <span @click="cleanUpEvt" class="all_text">All</span>
                  <span @click="dialogVisible_one = true"  style="    line-height: 26px; width: 80px;  height: 26px;  cursor: pointer;display: flex;  border: 1px solid rgb(179, 183, 188);
                            margin-left: 10px; justify-content: center;border-radius: 5px;margin-right: 10px;    font-size: 13px;
                            color: #787373; ">Filter</span>
                            
                <el-tooltip effect="dark" content="作者" placement="bottom-start" style="height:28px;line-height: 0px;">
                     <div>
                        <el-input v-if="username" style="width: 127px;" size="mini" placeholder="作者" v-model="username" clearable
                        @change="getList"  :class="{ 'vip': username && username.length != '0' }" ></el-input>
                     </div>
                </el-tooltip>
           

                <el-tooltip effect="dark" content="生成模型" placement="bottom-start" style="height:28px;line-height: 0px;">
                     <div>
                      <el-select  v-if="type_name "
                        v-model="type_name"
                        placeholder="生成模型"
                        filterable
                        clearable
                        size="mini"
                        style="width:127px;height:37px;margin-left: 3px;"
                        :class="{ 'vip': RechargeName && RechargeName !== '全部' }"
                        @change="RechargeEvt"
                      >
                        <!-- 循环渲染所有选项 -->
                        <el-option
                          v-for="item in modelOptions"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                     </div>
                </el-tooltip>

                <el-tooltip effect="dark" content="文字描述" placement="bottom-start" style="height:28px;line-height: 0px;">
                     <div>
                      <el-input v-if="origin_prompt" style="width: 127px;margin-left: 3px;" size="mini" placeholder="文字描述" v-model="origin_prompt" clearable
                      @change="getList"  :class="{ 'vip': origin_prompt && origin_prompt.length != '0' }"></el-input>
                     </div>
                </el-tooltip>
                <el-tooltip effect="dark" content="生成类型" placement="bottom-start" style="height:28px;line-height: 0px;">
                  <div>
                    <el-select v-if="selectedType" clearable  style="width: 127px;margin-left: 3px;"
                    size="mini"
                    placeholder="生成类型"
                    :class="{ 'vip': selectedType && selectedType.length != '0' }"
                    v-model="selectedType"
                    @change="getList">
                    <!-- 下拉选项：图片和视频 -->
                    <el-option label="图片" value="1"></el-option>
                    <el-option label="视频" value="2"></el-option>
                  </el-select>
                  </div>
                </el-tooltip>

                <el-tooltip effect="dark" content="生成时间" placement="bottom-start" style="height:28px;line-height: 0px;">
                  <div>
                    <el-date-picker v-if="value2 && value2.length" v-model="value2" type="daterange" start-placeholder="生成时间" value-format="timestamp"
                    align="right" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator="-"
                    style="width: 240px;margin-left: 3px;" @change="getList" class="border_box"
                    :class="{ 'your-css-class': !isValue2Empty }">
                  </el-date-picker>
                  </div>
                </el-tooltip>
                
                <el-tooltip effect="dark" content="公开情况" placement="bottom-start" style="height:28px;line-height: 0px;">
                  <div>
                    <el-select v-if="public" clearable  style="width: 127px;margin-left: 3px;"
                      size="mini"
                      placeholder="生成类型"
                      :class="{ 'vip':public &&public.length != '0' }"
                      v-model="public"
                      @change="alterEvt">
                      <!-- 下拉选项：图片和视频 -->
                      <el-option label="不公开" value="1"></el-option>
                      <el-option label="公开" value="2"></el-option>
                    </el-select>
                  </div>
                </el-tooltip>


                
                <el-tooltip effect="dark" content="生成条件" placement="bottom-start" style="height:28px;line-height: 0px;">
                
                  <div>
                    <el-select v-if="memberName" clearable  style="width: 127px;margin-left: 3px;"
                      size="mini"
                      placeholder="生成类型"
                      :class="{ 'vip':memberName && memberName.length != '0' }"
                      v-model="memberName"
                      @change="memberEvt">
                      <!-- 下拉选项：图片和视频 -->
                      <el-option label="免费" value="1"></el-option>
                      <el-option label="充值" value="2"></el-option>
                      <el-option label="内部" value="3"></el-option>
                    </el-select>
                  </div>

                </el-tooltip>
                <el-tooltip effect="dark" content="昵称选择" placement="bottom-start" style="height:28px;line-height: 0px;">
                  <div>
                    <el-input v-if="ncxz" style="width: 127px;margin-left: 3px;" size="mini" placeholder="昵称选择" :class="{ 'vip': ncxz && ncxz.length != '0' }" v-model="ncxz"
                    @change="getList"></el-input>
                  </div>
                </el-tooltip>
                
             
                <!-- <el-switch v-model="anniu" active-color="#409EFF" inactive-color="#e5e5e5" @change="getList">
                </el-switch> -->
          </div>
            <div class="pagination_box">
              <el-input v-model="paginationInput" style="width: 50px" size="mini" @change="limitEvt"
                placeholder="to"></el-input>
              <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
                :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="total" :pager-count="5"
                :show-total="showTotal">
              </el-pagination>
            </div>
          </div>
        </div>
        <div style="margin-top: 60px;overflow: unset;border-bottom: 1px solid #e1e1e1; margin-top: 1px solid #e1e1e1;">
          <el-table ref="sortTable" :data="tableData" :cell-style="rowStyle" :summary-method="getSummaries" height="55%"
            :empty-text="dataLoaded ? '暂无数据' : '正在加载数据中...'" @sort-change="sortChangeEvt" show-summary
            style="width: 100%; margin-top: 23px; overflow: none">
            <el-table-column sortable="custom" prop="id" width="100" label="编号" align="left" >
              <template slot-scope="props">
                <span style="height: 27px;width: 70px; display: flex; color: #c4c0c0;">
                  {{ props.row.id }}</span>
                <span style="height: 57px;width: 70px; display: flex;">
                  {{ props.row.create_time }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="" label="图像" width="500" align="left">
              <template slot-scope="props">
                <div style="display:flex;min-height:80px;margin-top: 10px;" class="chongfu">
                  <!-- 先过滤掉空或无效的 URL -->
                  <div
                    v-for="(image, index) in getValidImages(props.row)"
                    :key="index"
                    class="bg_img_e"
                    @click="openDialog(props.row, index)"
                  >
                    <img
                      :src="image"
                      alt=""
                      style="width:80px;height: 80px;object-fit: contain;background: #e5e5e5;"
                      loading="lazy"
                      @error="handleImageError(index)"
                    />
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column sortable="custom" prop="completed_at" label="结束时间" width="160" align="left">
              <template slot-scope="props">
                <span>{{ props.row.completed_at }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="" width="80" label="作者" align="left">
              <template slot-scope="props">
                <el-avatar :src="props.row.header_img"></el-avatar>
                <div style="display: flex;">
                  <span style="height: 57px;width: 60px; display: flex; font-size: 12px;">
                    {{ props.row.username }} </span>
                  <div
                    :class="{ 'disabled-row': props.row.is_active != '1', 'enabled-row': props.row.is_active == '1' }">
                    <el-dropdown trigger="click" @command="tableLevelEvt">
                      <span class="el-dropdown-link" @click="activeTextEvt(props.row)"
                        :style="{ color: props.row.is_active == '1' ? '#000' : '#e50026' }" style="font-size: 11px;">
                        {{ props.row.is_active == 1 ? '启用' : '禁用' }}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :disabled="props.row.is_active == '启用'" command="1">启用</el-dropdown-item>
                        <el-dropdown-item :disabled="props.row.is_active == '禁用'" command="2">禁用</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </template>
            </el-table-column>
             <el-table-column 
                sortable="custom" 
                prop="remark" 
                label="备注" 
                width="120" 
                align="left" 
              >
                <template slot-scope="props">
                <div class="notes_box" :data-row-id="props.row.id" ref="notesBox">
                  <!-- 给输入框加ref，且绑定行id -->
                  <el-input 
                    :ref="`editInput_${props.row.id}`"  
                    v-if="editShowUid === props.row.uid" 
                    v-model="editRemarkValue"
                    @keyup.enter.native.stop.prevent="determineEvt(props.row.uid)" 
                    @blur="editInpBlurEvt(props.row.uid)" 
                    placeholder="请输入内容"
                  ></el-input>
                  <!-- 点击时传递：行数据 + 行唯一id -->
                  <div class="name_box" v-else @click="editShowEvt(props.row, 'remark')">
                    <span class="remark-text">{{ props.row.remark }}</span>
                    <i class="el-icon-edit edit-icon"></i>
                  </div>
                </div>
              </template>
              </el-table-column>


            <el-table-column sortable="custom" prop="kind_name" width="100" label="生成类型" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="type_name" width="100" label="生成模型" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="coin" label="消耗币数量"  width="120" align="left"
              class-name="lie_three">
              <template slot-scope="props">
                <span :style="{ color: props.row.coin == 0 ? '#d1d1d1' : '#333' }">{{ props.row.coin }}</span>
              </template>
            </el-table-column>

            <el-table-column sortable="custom" prop="create_time" width="120" label="生成时间" align="left" v-if="0">
              <template slot-scope="props">
                <span style="height: 57px;width: 75px; display: flex; font-size: 12px;">
                  {{ props.row.create_time }}</span>
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="duration" width="80" label="总计" align="left"
              class-name="lie_three">
              <template slot-scope="props">
              <span :style="{ color: props.row.duration == 0 ? '#d1d1d1' : '#333' }">{{ props.row.duration }}</span>
            </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="update_time" width="80" label="运行" align="left"
              class-name="lie_three">
              <template slot-scope="props">
              <span :style="{ color: props.row.update_time == 0 ? '#d1d1d1' : '#333' }">{{ props.row.update_time }}</span>
            </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="wait_time" width="100" label="等待" align="left" class-name="lie_three">
              <template slot-scope="props">
              <span :style="{ color: props.row.wait_time == 0 ? '#d1d1d1' : '#333' }">{{ props.row.wait_time }}</span>
            </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="ip_addr" label="地址" width="110" align="left"
              class-name="lie_three">
            </el-table-column>
            <el-table-column prop="public" align="left" label="公开情况"  width="100">
              <template slot-scope="props">
                <el-switch
                  :active-value="2"
                  :inactive-value="1"
                  v-model="props.row.public"
                  active-color="#ff4949"
                  inactive-color="#e5e5e5"
                  @change="tablePublicEvt(props.row)">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="member" label="生成条件 "  align="left"
              class-name="lie_three">
              <template slot-scope="props">
                <span style="display: flex; font-size: 12px;"  :style="{
                      color: props.row.member === 1 ? '#e5e5e5' :
                            props.row.member === 2 ? '#dd117a' :
                            props.row.member === 3 ? '#000' : ''
                    }">
                  {{ props.row.member === 1 ? '免费' : props.row.member === 2 ? '充值' : props.row.member === 3 ? '内部' : '' }}</span>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" :top="dialogTop" width="70%" :show-close="false" class="bg_img"
      style="overflow: hidden;" :before-close="handleClose">
      <div style="width:100%;padding:15px;background-color: #fff;display: flex;position: relative;">

        <div style="min-width:300px;height:79vh;margin-right: 10px;overflow: auto;max-width: 200px;padding: 20px;position: relative;"
          class="custom-scrollbar">
          <div style="width: 100%;display: flex;justify-content: space-between;">
              <div class="fl_row" style="    font-weight: 600; font-size: 15px;">
                {{ data_ect.type_name }}
              </div>
              <div style="display: flex;">
                <div class="meta-item">
                    <img src="@/img/converted_4.png" alt="时长图标">
                    <span>{{ data_ect.duration }}</span>
                </div>
                <div class="meta-item">
                    <img src="@/img/converted_5.png" alt="积分图标">
                    <span>{{ data_ect.points }}</span>
                  </div>
              </div>
            </div>
          <div class="nav-container" style="margin-top:15px;pointer-events: none;"   v-if="[2,9].includes(data_ect.type)">
              <div :class="['button', { active_one: data_ect.k_type === 4 }]"> {{ '4k' }} </div>
              <div :class="['button', { active_one: data_ect.k_type === 6 }]"> {{ '6k' }} </div>
              <div :class="['button', { active_one: data_ect.k_type === 8 }]"> {{ '8k' }} </div>
            </div>
            <div style="width:250px;height:40px;margin-top:10px;" class="nav-container_one" v-show="[32,33,34].includes(data_ect.type)">
              <div  :class="{'active_Free': data_ect.type ===32}" class="button_one" style="width: 80px;">Seedance Pro Fast</div>
              <div  :class="{'active_Free': data_ect.type ===33}" class="button_one" style="width: 80px;">Seedance Lite</div>
              <div  :class="{'active_Free': data_ect.type === 34}" class="button_one" style="width: 80px;">Seedance Pro</div>
            </div>
            <div style="width:250px;height:40px;margin-top:10px;" class="nav-container_one" v-show="[29,30,31].includes(data_ect.type)">
              <div  :class="{'active_Free': data_ect.type ===29}" class="button_one" style="width: 80px;">HAILUO 23</div>
              <div  :class="{'active_Free': data_ect.type ===30}" class="button_one" style="width: 80px;">HAILUO 23-FAST</div>
              <div  :class="{'active_Free': data_ect.type === 31}" class="button_one" style="width: 80px;">HAILUO</div>
            </div>
            <div style="margin-top: 10px; background: rgb(241, 243, 253);border-radius: 11px;">
                <div style="width:250px;height:40px;" class="nav-container_one" v-show="[35,36,37,38,39].includes(data_ect.type)">
                  <div  :class="{'active_Free': data_ect.type === 35}" class="button_one" style="width: 80px;">VEO 3.1</div>
                  <div  :class="{'active_Free': data_ect.type === 36}" class="button_one" style="width: 80px;">VEO 3.1-FAST</div>
                  <div  :class="{'active_Free': data_ect.type === 37}" class="button_one" style="width: 80px;">VEO 3</div>
                </div>
                <div style="width:250px;height:40px;" class="nav-container_one" v-show="[35,36,37,38,39].includes(data_ect.type)">
                  <div  :class="{'active_Free': data_ect.type === 38}" class="button_one" style="width: 110px;">VEO 3-FAST</div>
                  <div  :class="{'active_Free': data_ect.type === 39}" class="button_one" style="width: 110px;">VEO 2</div>
                </div>                 
            </div>
            <div
              style="width:250px;height:40px;margin-top:10px;"
              class="nav-container_one"
              v-show="[14 , 28].includes(data_ect.type)">
              <div  :class="{'active_Free': data_ect.type === 28}" class="button_one" style="width: 120px;">Nano Banana pro3</div>
              <div  :class="{'active_Free': data_ect.type === 14}" class="button_one" style="width: 120px;">Nano Banana 2</div>
            </div>
            <div  style="    background: #F1F3FD; border-radius: 11px;margin-top:10px">
              <div style="width:250px;height:40px;" class="nav-container_one" v-show="[16,17,18,19].includes(data_ect.type)">
                <div  :class="{'active_Free': data_ect.type === 16}" class="button_one" style="width: 120px;">Flux pro</div>
                <div  :class="{'active_Free': data_ect.type === 17}" class="button_one" style="width: 120px;">Flux pro ultra</div>
              </div>
              <div style="width:250px;height:40px;" class="nav-container_one" v-show="[16,17,18,19].includes(data_ect.type)">
                <div  :class="{'active_Free': data_ect.type === 18}" class="button_one" style="width: 120px;">Flux kontext pro</div>
                <div  :class="{'active_Free': data_ect.type === 19}" class="button_one" style="width: 120px;">Flux kontext max</div>
              </div>
            </div>
            <div style="width:250px;height:40px;margin-top:10px;" class="nav-container_one" v-show="[21,22,23].includes(data_ect.type)">
              <div :class="{'active_Free': data_ect.type === 21}" class="button_one" style="width: 80px;">Imagen4</div>
              <div  :class="{'active_Free': data_ect.type === 22}" class="button_one" style="width: 80px;">Imagen4-fast</div>
              <div :class="{'active_Free': data_ect.type === 23}" class="button_one" style="width: 80px;">Imagen4-ultra</div>
            </div>
            <div style="width:250px;height:40px;margin-top:10px;" class="nav-container_one" v-show="[26,27].includes(data_ect.type)">
              <div  :class="{'active_Free': data_ect.type === 26}" class="button_one" style="width: 120px;">Seedream 3</div>
              <div  :class="{'active_Free': data_ect.type === 27}" class="button_one" style="width: 120px;">Seedream 4</div>
            </div>      
            <div style="width:250px;height:40px;margin-top:10px;" class="nav-container_three" v-show="[1,4,8].includes(data_ect.type)">
              <div :class="{'active_Free': data_ect.type === 1}" class="button_three">创作1</div>
              <div :class="{'active_Free': data_ect.type === 4}" class="button_three">创作2</div>
              <div :class="{'active_Free': data_ect.type === 8}" class="button_three">创作3</div>
            </div>   
            <div class="nav-container" style="margin-top:15px;"  v-if="[2,9].includes(data_ect.type)">
                <div  :class="{'active_one': data_ect.type === 2}" class="button_one" >柔和自然</div>
                <div  :class="{'active_one': data_ect.type === 9}" class="button_one">精细锐利</div>
            </div>
          <div class="drag-and-drop-uploader"     v-if="!data_ect.list_e">
            <img :src="data_ect.url" alt="" style="width:100%;height: 100%;object-fit: cover;" >
          </div>
          <div style="width:255px;height:80px;margin: auto;margin-top:30px;display:flex; justify-content: space-between;"
              v-if="data_ect.list_e">
              <div
                v-for="(item, index) in data_ect.list_e"
                :key="index"
                style="width:80px;height:80px;border:1px solid;border-radius:8px;margin-bottom:8px;">
                <!-- 当 item 存在且包含 url 属性时，渲染图片 -->
                <img
                  v-if="item && item.key"
                  :src="item.key"
                  alt=""
                  style="width: 100%;object-fit: contain;height:100%;border:none;cursor:auto;">
              </div>
          </div>
          <div style="margin-top:5px;width:255px;height: 180px;background: rgb(225, 225, 225); border-radius: 8px;
            padding: 10px;overflow: hidden auto;" v-if="data_ect.origin_prompt">
            <div >
              <span style="margin-left:12px;font-size: 12px;"> {{ data_ect.origin_prompt }}</span>
            </div>
          </div>
          <div  v-if="data_ect.type == 1 || data_ect.type == 3 || data_ect.type == 4 || data_ect.type == 8  ">
            <div v-if="data_ect.style" class="drag-and-drop-uploader">
                <img :src="data_ect.style" alt="" style="width: 100%;height: 100%;object-fit: cover;" />
              </div>
              <div v-if="data_ect.refer_tag && data_ect.refer_tag.length" style="margin: 0 0 10px 0 ;">
                <el-tag v-for="tag in data_ect.refer_tag" :key="tag.name" :type="tag.type" class="tag_e"
                  style="margin:2px;">
                  <span style="font-size: 12px;">{{ tag }}</span>
                </el-tag>
              </div>
          </div>
          
          <div v-if="![10,13,14].includes(data_ect.type)" style="display: flex;justify-content: center;width: 100%;">
            <div>
              <div v-if="data_ect.denoise !==0">
                <span style=" font-size:12px;margin-left: 10px;">
                  {{ data_ect.type == 1 ? '重绘幅度' : (data_ect.type == 3 || data_ect.type == 4 || data_ect.type == 8 ) ? '参考相似度' : '' }}
                </span>
                <el-slider v-model="data_ect.denoise" :class="determineClass_ect" style="width:230px"
                class="slow_mot_modified"  disabled></el-slider>
              </div>

              <div v-if="data_ect.increase !== 0">
                <span style="font-size:12px;margin-left: 10px;">
                  {{ data_ect.type == 1 ? '结构变化程度' : (data_ect.type == 2 ? '结构变化程度' : '参考相似度') }}
                </span>
                <el-slider v-model="data_ect.increase" :class="data_ect.increase == 28 ? 'class-if' : 'class-if-not'"
                class="slow_mot_modified"   style="width:230px" disabled></el-slider>
              </div>
              <!-- 放大 type== 2  -->
              <div v-if="data_ect.weight !== 0">
                <span style="font-size:12px;margin-left: 10px;">
                  {{ (data_ect.type == 1 || data_ect.type == 2 )? '参考相似度' : (data_ect.type == 3 || data_ect.type == 4
                  || data_ect.type == 5 || data_ect.type == 8) ? '结构变化程度': ''}}
                </span>
                <el-slider class="slow_mot_modified" v-model="data_ect.weight" :class="determineClass" style="width:230px" disabled></el-slider>
              </div>
            </div>
          </div>
         <div style="display: flex;justify-content: space-between;align-items: center;   position: absolute; bottom: 10px;width: 90%;">
          <div style="display: flex;align-items: center;justify-content: center; ">
            <div style="width: 25px;  height: 25px;  border-radius: 50%;  background: rgb(199, 199, 199); line-height: 35px;text-align: center;">
                <el-avatar style="width: 22px;height: 22px;border-radius: 50%;" :src="data_ect.header_img"></el-avatar>
            </div>
              <span style="margin-left: 10px;">{{data_ect.username }} </span>
          </div>
            <div >{{ data_ect.create_time }}</div>
         </div>

        </div>
        <div v-if="![13,15,29,30,31,32,33,34,35,36,37,38,39,40,41,42].includes(data_ect.type)"  class="image-wrapper" @wheel="handleWheel" @mousedown="startDrag" @mousemove="onDrag" @mouseup="stopDrag"
          @dblclick="resetPosition">
          <img :src="dialogImageUrl" alt="" style="height:720px;width:100%;object-fit: contain;background:#f9f9f9;"
            class="bg_img_evt" :style="imageStyle" name="viewArea" id="viewArea" draggable="false">
        </div>
        <div v-if="[13,15,29,30,31,32,33,34,35,36,37,38,39,40,41,42].includes(data_ect.type)" class="video-wrapper" style="height:720px;width:100%;background:#f9f9f9;display:flex;align-items:center;justify-content:center;">
          <video :src="dialogVideoUrl"
            controls autoplay  loop
            style="max-height:100%;max-width:100%;object-fit:contain;"
            poster="视频封面图URL">
          </video>
        </div>
      </div>
      <div @click="prevImage" class="prev-button"></div>
      <div @click="nextImage" class="next-button"></div>

      <div @click="prevRow" class="prev-row-button"></div> <!-- 上一行按钮 -->
      <div @click="nextRow" class="next-row-button"></div> <!-- 下一行按钮 -->
      <span
        style="margin-right: 30px; width: 100px; height: 30px;line-height:30px; position: absolute;bottom: 20px;right: 0px;background: #959595;border-radius: 24px;text-align: center;color: #fff;">
        {{ data_ect.url_width ||data_ect.width  }}
        <span v-if="data_ect.url_width && data_ect.url_height  || data_ect.width && data_ect.height">x</span>
        {{ data_ect.url_height || data_ect.height }}
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible_one" width="1400" custom-class="sousuo" :show-close="false">
        <div style="height:250px;">
          <div>
            <span
              style="width: 69px;border: 1px solid #589ff9;height: 26px;font-size: 12px;line-height: 26px;color: #589ff9;border-radius: 3px;cursor: pointer;display: flex;justify-content: center;margin: 0 40px 30px 90px;"
              @click="cleanUpEvt">ALL</span>
          </div>
          <div style="height:300px;display:flex">
            <div>
              <div class="all_input">
                <span>作者</span>
                <el-input style="width: 127px;margin-top: 5px;" size="mini" placeholder="作者" v-model="username" clearable
                @change="getList"  :class="{ 'vip': username && username.length != '0' }" ></el-input>
              </div>
              <div class="all_input">
                <span>文字描述</span>
                <el-input style="width: 127px;margin-top: 5px;" size="mini" placeholder="文字描述" v-model="origin_prompt" clearable
                @change="getList"  :class="{ 'vip': origin_prompt && origin_prompt.length != '0' }"></el-input>
              </div>
              <div class="all_input">
                <span>昵称选择</span>
                <el-input style="width: 127px;margin-top: 5px;" size="mini" placeholder="昵称选择" :class="{ 'vip': ncxz && ncxz.length != '0' }" v-model="ncxz"
                @change="getList"></el-input>
              </div>
            </div>
            <div>
              <div class="all_input">
                  <span>生成时间</span>
                  <el-date-picker v-model="value2" type="daterange" start-placeholder="生成时间" value-format="timestamp"
                  align="right" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator="-"
                  style="width: 127px;margin-top: 5px;" @change="getList" class="border_box"
                  :class="{ 'your-css-class': !isValue2Empty }">
                </el-date-picker>
              </div>
              <div class="all_input">
                <span>生成类型</span>
                <!-- 替换后的 el-select 下拉选择器 -->
                <el-select   style="width: 127px;margin-top: 5px;"
                  size="mini"
                  clearable
                  placeholder="生成类型"
                  :class="{ 'vip': selectedType && selectedType.length != '0' }"
                  v-model="selectedType"
                  @change="getList"
                >
                  <!-- 下拉选项：图片和视频 -->
                  <el-option label="图片" value="1"></el-option>
                  <el-option label="视频" value="2"></el-option>
                </el-select>
              </div>
              <div class="all_input">
                  <span>生成模型</span>
                  <!-- 替换原有的el-dropdown为可搜索的el-select -->
                  <el-select
                    v-model="type_name"
                    placeholder="生成模型"
                    filterable
                    clearable
                    size="mini"
                    style="width:127px;height:37px"
                    :class="{ 'vip': RechargeName && RechargeName !== '全部' }"
                    @change="RechargeEvt"
                  >
                    <!-- 循环渲染所有选项 -->
                    <el-option
                      v-for="item in modelOptions"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    ></el-option>
                  </el-select>
              </div>
            </div>
            <div>
                <div class="all_input">
                  <span>公开情况</span>
                      <el-select
                        v-model="public"
                        placeholder="公开情况"
                        filterable
                        clearable
                        size="mini"
                        style="width:127px;height:37px"
                        :class="{ 'vip': public && public !== '全部' }"
                        @change="alterEvt"
                      >
                        <!-- 循环渲染所有选项 -->
                        <el-option label="不公开" value="1"></el-option>
                        <el-option label="公开" value="2"></el-option>
                      </el-select>
                </div>
                <div class="all_input">
                  <span>生成条件</span>
                    <el-select
                        v-model="memberName"
                        placeholder="生成条件"
                        filterable
                        clearable
                        size="mini"
                        style="width:127px;height:37px"
                        :class="{ 'vip': memberName && memberName !== '全部' }"
                        @change="memberEvt">
                        <!-- 循环渲染所有选项 -->
                        <el-option label="免费" value="1"></el-option>
                        <el-option label="充值" value="2"></el-option>
                        <el-option label="内部" value="3"></el-option>
                      </el-select>
                </div>
              </div>
          </div>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import { Aiapi, editListApi, alterApi ,TypeNameApi} from "../../../apis/ai"
const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
export default {
  data() {
    return {
      dialogVisible_one:false,
      dialogVisible: false,
      dialogImageUrl: '',
      currentImages: [], // 当前点击行的所有图片，包括主图和生成图
      currentIndex: 0, // 当前显示的图片索引
      clickedIndex: null,
      dialogTop: null, // 初始值为1vh
      data_ect: [],
      origin_prompt: null,

      header: true,
      src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      //备注
      remtInput: "",
      authorIdInput: "",
      localInput: "",
      last_login: "",
      //分页输入框数据
      paginationInput: 10,
      currentPage1: 1,
      type: 4,
      //分页总数据
      total: null,
      sum: null,
      value2: "",
      isValue2Empty: true,
      id: null,
      username: null,
      ncxz:null,
      anniu:false,
      selectedType:'',
      duration: null,
      RechargeName: '全部',
      type_name:'',

      modelOptions:[],
      // 保持原有的映射关系
      typeMap: {
        "1": "创作1",
        "2": "优化放大",
        "3": "创作2.0",
        "4": "创作2",
        "5": "放大2.0",
        "7": "全部",
        "8": "创作3",
        "9": "新放大",
        "10": "抠图",
        "11": "去水印",
        "12": "人物合成",
        "13": "Topaz",
        "14": "Nano Banana Pro",
        "15": "Gemini Banana",
        "16": "Flux pro",
        "17": "Flux pro ultra",
        "18": "Flux kontext pro",
        "19": "Flux kontext max",
        "20": "Ideogram 生图",
        "21": "Imagen4",
        "22": "Imagen4",
        "23": "Imagen4",
        "24": "Qwen",
        "25": "Runway",
        "26": "Seedream",
        "27": "Seedream",
        "28": "Nano Banana Pro 3",
        "29": "HAILUO",
        "30": "HAILUO",
        "31": "HAILUO",
        "32": "Seedance",
        "33": "Seedance",
        "34": "Seedance ",
        "35": "VEO",
        "36": "VEO",
        "37": "VEO",
        "38": "VEO3",
        "39": "VEO",
        "40": "VIDUQ",
        "41": "LUMA",
        "42": "RAY",
        "43": "Magnific"
      },

      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
              picker.$emit('pick', [new Date(start.setHours(0, 0, 0, 0)), new Date(end.setHours(23, 59, 59, 0))]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
              const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
              // picker.$emit("pick", [firstDate, lastDate]);
              picker.$emit('pick', [new Date(firstDate.setHours(0, 0, 0, 0)), new Date(lastDate.setHours(23, 59, 59, 0))]);

            },
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              // picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
              picker.$emit('pick', [new Date(thisMonthStartDate.setHours(0, 0, 0, 0)), new Date(thisMonthEndDate.setHours(23, 59, 59, 0))]);
            },
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              // picker.$emit("pick", [startTime, endTime]);
              picker.$emit('pick', [new Date(startTime.setHours(0, 0, 0, 0)), new Date(endTime.setHours(23, 59, 59, 0))]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const temp = new Date();
              temp.setTime(temp.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [new Date(temp.setHours(0, 0, 0, 0)), new Date(temp.setHours(23, 59, 59, 0))]);
            }
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit('pick', [new Date(firstDate.setHours(0, 0, 0, 0)), new Date(lastDate.setHours(23, 59, 59, 0))]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            },
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
        ],
      },
      laiyuan: null,
      input: "",
      editShowInp: null,
      editName: null,
      tableData: [],
      totalRow: null,
      //排序
      order: null,
      orField: null,
      activeId: null,
      deleteVisible: false,
      data: {},
      num: null,
      count: 0,
      pagefenye: false,//点击分页 滚动条为0
      loading: false,
      dataLoaded: false, // 表格数据是否加载完成的状态
      c: 1,
      pre1: 0,
      pre2: 0,
      pre3: 0,

      scale: 1,
      scaleStep: 0.1,
      maxScale: 3,
      minScale: 0.5,
      isDragging: false,
      startX: 0,
      startY: 0,
      lastMouseX: 0,
      lastMouseY: 0,
      translateX: 0,
      translateY: 0,
      dragFrameId: null,
      alterAI:'公开情况',
      public:null,
      PublicId:null,
      activeNames: ['1','2','3','4'], // 作为 v-model 的目标
      member:'生成条件',
      memberName:null,
        editShowUid: null, // 当前正在编辑的uid（全局唯一，确保同一时间只编辑一个uid）
      editRemarkValue: '', // 存储当前uid的编辑值
      isSubmitting: false // 请求锁，防止重复提交
    };
  },
  created() {
    this.loading = true
    if (this.$store.getters.location == '') {
      this.c = 1
    }
    this.c = this.$store.getters.location;
    Aiapi({ c: this.c }).then((res) => {
      this.tableData = res.data.data;
      this.total = res.data.count.total;
      this.sum = res.data.count;
      this.paginationInput = res.data.limit;
      this.loading = false
    });

    TypeNameApi({  }).then((res) => {
      this.modelOptions = res.data;
    });

    //监听鼠标按下抬起事件
    window.addEventListener("keydown", this.handKeyCode, true);
    window.addEventListener('keyup', this.handKeyEvt);
  },
  beforeDestroy() {
    // 在组件生命周期结束的时候销毁
    window.removeEventListener("keydown", this.handKeyCode, false);
    window.removeEventListener("keyup", this.handKeyEvt, false);
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    //监听页面滚动条事件
    window.addEventListener("scroll", (e) => this.imgScrollEvt(e), true);
    // 在mounted钩子中监听窗口尺寸变化，根据不同尺寸修改dialogTop的值
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    this.c = this.$store.getters.location;
  },
  computed: {
    computedActiveNames() {
      let names = [];
      if (this.data_ect.style || (this.data_ect.refer_tag && this.data_ect.refer_tag.length)) names.push('1');
      if (this.data_ect.z) names.push('2');
      if (this.data_ect.origin_prompt) names.push('3');
      if (
        this.data_ect.denoise !== 80 || this.data_ect.denoise !== 100 ||
        this.data_ect.weight !== 30
      ) {
        names.push('4');
      }
      return names;
    },
    imageStyle() {
      return {
        transform: `scale(${this.scale}) translate(${this.translateX}px, ${this.translateY}px)`,
        transformOrigin: 'center center'
      };
    },
    determineClass() {
      //结构变化程度
      const { type, weight } = this.data_ect;
        const config = {
          1: 67,
          3: 100,
          4: 60,
          8: 63,
          9: 25,
          2: 28

        };

        // 检查当前类型是否在配置中，并且权重是否匹配配置值
        const isMatch = config.hasOwnProperty(type) && weight === config[type];

        return isMatch ? 'class-if' : 'class-if-not';
    },

    determineClass_ect() {
       //结构变化程度
       const { type, denoise } = this.data_ect;
        const config = {
          1: 35,
          3: 100,
          4: 100,
          8: 100,
        };

        // 检查当前类型是否在配置中，并且权重是否匹配配置值
        const isMatch = config.hasOwnProperty(type) && denoise === config[type];

        return isMatch ? 'class-if' : 'class-if-not';
    }
  },
  methods: {
    getValidImages(row) {
      const allImages = [row.url, ...(row.gen_url || [])];
      return allImages.filter(img => img && typeof img === 'string' && img.trim() !== '');
    },
    // 图片加载失败时移除该图片
    handleImageError(index) {
      // 注意：这里需要根据你的数据结构来更新数组，示例中假设图片列表是响应式的
      // 例如，如果图片列表是在组件的 data 中，可以这样：
      // this.images.splice(index, 1);
      // 如果是在 props.row 中，可能需要通过事件通知父组件更新数据
      console.warn(`图片加载失败，已移除: ${this.getValidImages(this.props.row)[index]}`);
      // 实际项目中，建议将图片列表存储在组件的 data 中，以便直接修改
    },

    //缩放图片
    handleWheel(event) {
        event.preventDefault(); // 阻止默认滚动行为
        const images = document.querySelectorAll('.image-wrapper img');
        // 获取滚动方向
        if (event.deltaY < 0) {
          // 向前滚动时放大
          if (this.scale < this.maxScale) {
            this.scale += this.scaleStep;
          } else {
            return; // 如果已经是最大缩放比例，则直接返回，不做任何操作
          }
        } else if (event.deltaY > 0) {
          // 向后滚动时缩小
          if (this.scale > this.minScale) {
            this.scale -= this.scaleStep;
          } else {
            return; // 如果已经是最大缩放比例，则直接返回，不做任何操作
          }
        }
        // 同步缩放两张图片
        images.forEach(img => {
          const rect = img.getBoundingClientRect(); // 获取图像的位置信息
          const xPercent = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
          const yPercent = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));

          // 设置缩放中心为鼠标位置
          const transformOrigin = `${xPercent}% ${yPercent}%`;

          // 更新样式
          img.style.transform = `scale(${this.scale})`;
          img.style.transformOrigin = transformOrigin;
        });
    },
    resetPosition() {
      this.translateX = 0;
      this.translateY = 0;
      this.scale = 1;
    },
    startDrag(event) {
      event.preventDefault();
      this.isDragging = true;
      this.startX = event.clientX - this.translateX;
      this.startY = event.clientY - this.translateY;
    },
    onDrag(event) {
      event.preventDefault();
      if (this.isDragging) {
        if (!this.dragFrameId) {
          this.dragFrameId = requestAnimationFrame(() => {
            this.translateX = event.clientX - this.startX;
            this.translateY = event.clientY - this.startY;
            this.dragFrameId = null;
          });
        }
      }
    },

    stopDrag(event) {
      event.preventDefault();
      this.isDragging = false;
      if (this.dragFrameId) {
        cancelAnimationFrame(this.dragFrameId);
        this.dragFrameId = null;
      }
    },
    tableLevelEvt(res) {
      let str = "";
      switch (this.num) {
        case "1":
          str = "启用";
          break;
        case "2":
          str = "禁用";
          break;
      }
      editListApi({
        id: this.activeId,
        field: "is_active",
        val: res,
      }).then((e) => {
        this.tableData = this.tableData.map((val) => {
          if (val.uid == this.activeId) {
            val.is_active = parseInt(res); // 确保 is_active 是数字类型
          }
          return val;
        });
      });
    },


    tablePublicEvt(res){
      console.log(res,213);
      alterApi({
        id: res.id,
        field: "public",
        val: res.public,
      }).then((e) => {
        this.tableData = this.tableData.map((val) => {
          if (val.id == this.PublicId) {
            val.public = parseInt(res); // 确保 is_active 是数字类型
          }
          return val;
        });
      });
    },
    activeTextEvt(res) {
      this.activeId = res.uid;
    },

    handleResize() {
      // 根据不同的屏幕尺寸设置不同的top值
      if (window.innerWidth <= 1920) {
        this.dialogTop = '5vh'
      } else if (window.innerWidth <= 2560) {
        this.dialogTop = '12vh'
      } else if (window.innerWidth <= 3440) {
        this.dialogTop = '15vh'
      } else if (window.innerWidth <= 3840) {
        this.dialogTop = '20vh'
      }
    },

    handleClose() {
      this.$nextTick(() => {
        this.currentImages = [],
        this.scale = 1;
        this.translateX = 0;
        this.translateY = 0;
        this.startX = 0;
        this.startY = 0;
        this.dialogVisible = false
        this.dialogImageUrl = []
      })
    },
    openDialog(item, index) {
      this.data_ect = { ...item }; // 获取数据
        // 根据类型处理媒体资源
        if ([13,15,29,30,31,32,33,34,35,36,37,38,39,40,41,42].includes(this.data_ect.type)) {
          // 视频类型
          // 确保视频URL正确设置
          this.dialogVideoUrl = this.data_ect.video_url
          console.log(this.dialogVideoUrl, '视频');
        } else {
          // 图片类型，保持原有的图片处理逻辑
          const urlBigImages = Array.isArray(item.url_big) ? item.url_big : [item.url_big];
          const genUrlBigImages = Array.isArray(item.gen_url_big) ? item.gen_url_big : [item.gen_url_big];
          const styleImages = Array.isArray(item.style) ? item.style : [item.style];
          const zImages = Array.isArray(item.z) ? item.z : [item.z];

          this.currentImages = [
            ...urlBigImages,
            ...genUrlBigImages,
            ...styleImages,
            ...zImages
          ].filter(imageUrl => imageUrl);

          this.currentIndex = index < this.currentImages.length ? index : 0;
          this.dialogImageUrl = this.currentImages[this.currentIndex] || '';

          // 设置尺寸信息
          if (urlBigImages.includes(this.dialogImageUrl)) {
            this.data_ect.url_width = item.url_width;
            this.data_ect.url_height = item.url_height;
          } else {
            this.data_ect.url_width = item.large_width;
            this.data_ect.url_height = item.large_height;
          }
        }

        // 显示对话框并重置状态
        this.dialogVisible = true;
        this.scale = 1;
        this.translateX = 0;
        this.translateY = 0;
        this.startX = 0;
        this.startY = 0;
    },
    prevImage() {
      if (this.currentImages.length > 0) {
        if (this.currentIndex > 0) {
          this.currentIndex--;
        } else {
          this.currentIndex = this.currentImages.length - 1; // 切换到最后一页
        }
        this.updateImageDimensions();
        this.dialogImageUrl = this.currentImages[this.currentIndex];
      }
    },
    nextImage() {
      if (this.currentImages.length > 0) {
        if (this.currentIndex < this.currentImages.length - 1) {
          this.currentIndex++;
        } else {
          this.currentIndex = 0; // 切换到第一页
        }
        this.updateImageDimensions();
        this.dialogImageUrl = this.currentImages[this.currentIndex];
      }
    },
    prevRow() {
      const currentRowIndex = this.tableData.findIndex(row => row.id === this.data_ect.id);
      if (currentRowIndex > 0) {
        this.openDialog(this.tableData[currentRowIndex - 1], 0);
      }
    },
    nextRow() {
      const currentRowIndex = this.tableData.findIndex(row => row.id === this.data_ect.id);
      if (currentRowIndex < this.tableData.length - 1) {
        this.openDialog(this.tableData[currentRowIndex + 1], 0);
      }
    },
    updateImageDimensions() {
      const currentImage = this.currentImages[this.currentIndex];
      const originalImage = this.tableData.find(row => row.id === this.data_ect.id);

      if (originalImage.url_big.includes(currentImage)) {
        this.data_ect.url_width = originalImage.url_width;
        this.data_ect.url_height = originalImage.url_height;
      } else {
        this.data_ect.url_width = originalImage.large_width;
        this.data_ect.url_height = originalImage.large_height;
      }
    },
    //分页只显示前三页加总数
    showTotal(total) {
      return `共 ${total} 页`;
    },
    //按下键盘事件
    handKeyCode(e) {
      e = e || window.event;
      //Page Up 翻页
      if (this.dialogVisible){
        e.preventDefault();
        if (e.keyCode === 37 || e.keyCode === 33 || e.keyCode === 105) {
          this.prevImage()
        }
        if (e.keyCode === 39 || e.keyCode == 34 || e.keyCode === 99) {
          this.nextImage()
        }
        if (e.keyCode === 38) {
          this.prevRow()
        }
        if (e.keyCode === 40) {
          this.nextRow()
        }
      };
    },

    limitEvt() {
      this.getList();
    },
    //滑动事件
    imgScrollEvt(e) {
      var e =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        e ||
        document.body.scrollTop;
      //点击分页 滚动条为0
      if (this.pagefenye == true) {
        e.scrollTop = 0;
        this.pagefenye = false
        return
      }

    },
    //分页
    handleCurrentChange(res) {
      this.loading = true
      setTimeout(() => {
        this.getList()
        this.loading = false
      }, 500)
    },
    //
    rowStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label == "等级") {
        return {};
      } else if (column.label == "昵称") {
        return {};
      }
    },
    //列表排序
    sortChangeEvt(row) {
      if (row.order == "ascending") {
        this.order = "asc";
      } else if (row.order == "descending") {
        this.order = "desc";
      }
      this.orField = row.prop;
      this.getList();
    },
    //显示修改输入框
  editShowEvt(row, name) {
      this.editShowUid = row.uid;
      this.editRemarkValue = row.remark || '';
      this.editName = name;

      // 核心：多次尝试聚焦，确保生效（$nextTick + 延迟，覆盖渲染延迟）
      this.$nextTick(() => {
        this.focusTargetInput(row.id);
        // 兜底：如果第一次没聚焦，100ms后再试一次（应对渲染慢的情况）
        setTimeout(() => {
          this.focusTargetInput(row.id);
        }, 100);
      });
    },

    // 独立的聚焦方法：精准 + 原生DOM兜底
    focusTargetInput(rowId) {
      try {
        // 方案1：通过唯一ref直接获取（最精准）
        const inputRef = this.$refs[`editInput_${rowId}`];
        if (inputRef) {
          // 优先用Element UI的focus
          inputRef.focus();
          // 降级：用原生input聚焦（必生效）
          const nativeInput = inputRef.$el.querySelector('input');
          if (nativeInput) nativeInput.focus();
          return;
        }

        // 方案2：兜底 - 遍历所有输入框，按row-id匹配
        const inputRefs = this.$refs.editInput;
        if (!inputRefs) return;
        const inputs = Array.isArray(inputRefs) ? inputRefs : [inputRefs];
        
        const targetInput = inputs.find(input => {
          const notesBox = input.$el.closest('.notes_box');
          return notesBox && notesBox.dataset.rowId === rowId.toString();
        });

        if (targetInput) {
          targetInput.focus();
          const nativeInput = targetInput.$el.querySelector('input');
          if (nativeInput) nativeInput.focus();
        }
      } catch (e) {
        console.error('聚焦失败：', e);
      }
    },
    async submitEdit() {
      // 防重复提交 + 空值校验
      if (this.isSubmitting || !this.editShowUid) return;
      
      try {
        this.isSubmitting = true;
        // 发起请求：只传uid，后台按uid批量修改所有对应行的备注
        const res = await editListApi({
          id: this.editShowUid, // 这里id实际传的是uid，对应后台批量修改逻辑
          field: this.editName,
          val: this.editRemarkValue.trim()
        });

        // 请求成功后：更新前端所有相同uid行的备注
        this.tableData = this.tableData.map(item => {
          if (item.uid === this.editShowUid) {
            return { ...item, remark: this.editRemarkValue.trim() };
          }
          return item;
        });

        // 关闭编辑状态
        this.editShowUid = null;
        this.editRemarkValue = '';
        this.$message.success('备注修改成功');
      } catch (error) {
        console.error('备注修改失败：', error);
        this.$message.error('备注修改失败，请重试');
      } finally {
        this.isSubmitting = false; // 释放锁
      }
    },

    // 回车确认
    determineEvt() {
      this.submitEdit();
    },

    // 失焦确认
    editInpBlurEvt() {
      this.submitEdit();
    },
  


    getSummaries(param) {
      // 检查 this.sum 是否已定义并且不是空对象
      if (!this.sum || Object.keys(this.sum).length === 0) {
        // 返回一个默认的 sums 数组，或者提示用户数据正在加载
        return new Array(param.columns.length).fill(null);
      }
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        for (let key in this.sum) {
          if (column.property === key) {
            sums[index] = this.sum[key];
          }
        }
        if (index === 0) {
          console.log(this.sum.total, "this.sum.total");
          sums[index] = this.sum.total;
          return;
        }else if (index === 3) {
          sums[index] = this.sum.user;
          return;
        }
      });

      return sums;
    },
    //点数情况
    RechargeEvt(res) {
        // 设置名称和类型
        this.RechargeName = this.typeMap[res] || '未知功能';
      // 全部选项清空type_name，其他选项设置为对应的res
      this.type_name = res === "7" ? "" : res;
      // 同步选中值
      this.selectedModel = res;
      // 调用列表接口
      this.getList();
    },
    alterEvt(res) {
      switch (res) {
        case "1":
          this.alterAI = "不公开";
          this.public = res;
          break;
        case "2":
          this.alterAI = "公开";
          this.public = res;
          break;
      }
      this.getList();
    },
    memberEvt(res) {
      switch (res) {
        case "1":
          this.member = "免费";
          this.memberName = res;
          break;
        case "2":
          this.member = "充值";
          this.memberName = res;
          break;
        case "3":
        this.member = "内部";
        this.memberName = res;
        break;
      }
      this.getList();
    },
    //获取页面数据
    getList() {
      let date = {
        start: this.value2 && this.value2[0] ? this.value2[0] : null,
        end: this.value2 && this.value2[1] ? this.value2[1] : null,
      }
      var start = date.start ? Math.floor(date.start / 1000) : null;
      var end = date.end ? Math.floor(date.end / 1000) : null;
      if (end !== null) {
        // 将选定的日期转换为当天的最后一秒
        var lastVaccineDate = new Date(end * 1000);
        lastVaccineDate.setHours(23, 59, 59);
        end = Math.floor(lastVaccineDate.getTime() / 1000);
      }

      Aiapi({
        create_time_start: start || '',
        create_time_end: end || '',
        username: this.username,
        origin_prompt: this.origin_prompt,
        type_name: this.type_name,

        ncxz: this.ncxz,
        anniu: this.anniu ? 2 : 1,

        page: this.currentPage1,
        orField: this.orField,
        orWhere: this.order,
        limit: this.paginationInput,
        c: this.c,
        public: this.public,
        member:this.memberName,
        kind_name:this.selectedType,
      }).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.count.total;
        this.totalRow = res.totalRow;
        this.sum = res.data.count;
        this.pagefenye = true;  //点击分页 滚动条为0
        let as = document.querySelector('.el-table__body-wrapper')
        as.scrollTop = 0
        this.imgScrollEvt(as)
        this.loading = false;
        this.dataLoaded = true; // 数据加载完成，修改dataLoaded的状态
      });


    },
    //清除搜索条件
    cleanUpEvt() {
      this.RechargeName = '全部'
      this.type_name = ''
      this.authorIdInput = ''
      this.remtInput = ''
      this.value2 = ''
      this.id = ''
      this.username = ''
      this.origin_prompt = ''
      this.currentPage1 = 1;
      this.alterAI = '公开情况'
      this.public = ''
      this.member = '生成条件'
      this.memberName = ''
      this.ncxz = ''
      this.anniu = false,
      this.orField= ''
      this.order = ''
      this.selectedType = '';
      this.$refs.sortTable.clearSort();
      Aiapi({
        c: this.c
      }).then((res) => {
        this.tableData = res.data.data;
        this.paginationInput = res.data.limit;
        // this.currentPage1 = res.page ;
        this.total = res.data.count.total;
        this.sum = res.data.count;
        this.pagefenye = true;  //点击分页 滚动条为0
        let as = document.querySelector('.el-table__body-wrapper')
        as.scrollTop = 0
        this.imgScrollEvt(as)
        this.loading = false;
      });
    },

    clearEvt1() {
      this.RechargeName = '请选择';
      AdminIcoMeLabelApi({
        c: this.c
      }).then((res) => {
        this.tableData = res.data.order;
        this.total = res.total;
        this.totalRow = res.totalRow;
      });
    },
    clearEvt2() {
      this.remtInput = ''
    }
  },

  watch: {
    '$store.getters.location': function (newLocation, oldLocation) {
      this.c = newLocation
    },
    'value2': function (newVal, oldVal) {
      this.isValue2Empty = !newVal;
    },
    selectedModel(newVal) {
      this.RechargeName = this.typeMap[newVal] || '未知功能';
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../../style/space.less");
@import url("../../../style/ai.less");
/deep/.el-table th.el-table__cell{
  background: #F5F7FA !important;
}
.item {
  margin-top: 10px;
}

/deep/.el-input__suffix {
  color: #409eff;
}

/deep/.el-main {
  overflow: unset !important;
}

.search_box {
  position: absolute;
  top: 20px;
  left: 50px;
  width: 320px;
  height: 470px;
  border-radius: 10px;
  background-color: #fff;
  display: flex;
  justify-content: space-evenly;
  z-index: 999;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 20px 10px;
  box-shadow: 0 0 10px 1px #e5e5e5;

  /*visibility: hidden;*/
  .num_box {
    width: 127px;
    border: 1px solid #e4e3e3;
    border-radius: 3px;
    margin-top: 5px;
  }
}


.all_text {
    background-color: #409eff;
    font-size: 13px;
    color: #fff;
    cursor: pointer;
    height: 26px;
    border-radius: 3px;
    width: 50px;
    text-align: center;
    line-height: 26px;
}

.caoz {
  margin-top: 8px;
  display: flex;
}

/* .block {
    position: absolute;
    margin-top: 9px;
    top: 0;
    right: 1%;
    transition: all 0.2s ease 0.5s;
  } */


.block1 {
  visibility: hidden;
}

.block1>div {
  display: none;
}

.clear {
  position: relative;
  height: 50px;

  span:nth-last-child(1) {
    background-color: #fff;
    border: 1px solid #e5e5e5;
    font-size: 13px;
    color: #c4c3c3;
    border-radius: 3px;
    position: absolute;
    right: 5px;
    bottom: -6px;
    padding: 0 10px;
    cursor: pointer;
  }

}


.demo-table-expand {
  background-color: #f2f2f2;
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  padding: 0 20px;
  width: 30%;
}

.name_box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  i {
    cursor: pointer;
    display: none;
  }
}

.name_box:hover>i {
  display: block;
}

.pagination_box {
  min-width: 500px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.num_box button {
  width: 125px;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  color: #ada8a8;
}
.num_box .vip{
  background: #bcd9f8d4 !important;
  color: #000;
}


.rowClassOne {
  background-color: #e7ecff;
}

.rowClassTwo {
  color: #222222;
  background-color: #1c43ce;
}

.rowClassThree {
  background-color: #6a88f1;
}

.el-dropdown-link {
  cursor: pointer;
}

.notes_box {
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.my-icon {
  cursor: pointer;
  width: 25px;
}

/deep/.el-table thead {
  font-size: 12px;
}


/* /deep/.el-table__header-wrapper {
    background-color: #F00 !important;
    overflow-y: scroll !important;
  }
  /deep/.el-table th.el-table__cell:nth-of-type(1){
    color: #f00;
    position: fixed;
  }
  /deep/.el-table th.el-table__cell:nth-of-type(2){
    color: #f00;
  }
  /deep/.el-table th.el-table__cell:nth-of-type(3){
    color: #f00;
  }
  /deep/.el-table__fixed, .el-table__fixed-right{
    overflow-y: scroll;
  } */

  //原本
/deep/.el-table__footer-wrapper {
  position: fixed;
  top: 115px;
  z-index: 111;
}


/deep/.el-table__fixed-footer-wrapper {
  display: none;
}

/deep/.el-badge__content.is-fixed {
  display: none;
}

/deep/.el-input__inner {
  color: #409eff;
  cursor: pointer;
}

.clear_ev {
  position: absolute;
  right: 10px;
}

.vip-button {
  color: #000 !important;
  background-color: #bcd9f8d4 !important;

}

.span_box_two {
  z-index: 889;
  width: calc(100% - 675px);
  height: 50px;
  border: 1px solid #F5F7FA;
  position: fixed;
  right: 0px;
  background: #F5F7FA;
  border: none;
  top: 109px;
}

.span_box {
  position: absolute;
  right: 1px;
  z-index: 999;
  height: auto;
  background-color: #F5F7FA;
  min-width: 240px;
  height: 48.6px;
  top: 39px;
  z-index: 9991;
  border: 1px solid #f5f7fa;
}

.blur {
  background-color: #fff;
}

/* 朝上排序样式 */
/deep/.el-table .ascending .sort-caret.ascending {
  background-color: #f00 !important;
  background: url("../../../img/12.png")no-repeat -4px -3px  !important;
  background-size: 11px 14px !important;
  width: 40px;
  height: 58px;
  z-index: 11;
}

/* 朝下排序样式 */
/deep/.el-table .descending .sort-caret.descending {
  background: url("../../../img/22.png")no-repeat -5px 2px !important;
  background-size: 11px 14px !important;
  width: 40px;
  height: 25px;

}

/deep/.el-table .descending .sort-caret.descending {
  border-top-color: #fff;
}

/* 朝上字体样式 */
/deep/.el-table__header .ascending .cell {
  color: #409EFF!important;
}

/* 朝下字体样式 */
/deep/.el-table__header .descending .cell {
  color: #409EFF!important;
}

.your-css-class {
  background-color: #bcd9f8d4 !important;
  z-index: 9999;

  input {
    background-color: #bcd9f8d4 !important;
  }
}

.your-css-class_box {
  background-color: #bcd9f8d4 !important;

  input {
    background-color: #bcd9f8d4 !important;
  }
}

.orange {
  /deep/.el-input__inner {
    background-color: #bcd9f8d4 !important;
    color: #222222;
  }

  /deep/.el-input__suffix {
    color: #222222;
  }
}

/deep/.el-input__inner {
  border: 1px solid #e5e5e5;
}

//调整日期选择器的盒子大小进行修改
/deep/.el-range-editor--mini {
  height: 28px !important;
  border: 1px solid #e5e5e5 !important;
}

.chongfu div:nth-child(2) {
  margin-left: 40px;
  cursor: pointer;
}

.chongfu div:nth-child(n+3) {
  margin-left: 5px;
  cursor: pointer;
}

// .bg_img_e {
//   overflow: hidden;
//   cursor: pointer;
// }

// .bg_img_e img:hover {
//   transform: scale(1.1);
// }


/* 弹窗按钮的样式 */
.prev-button,
.next-button,
.prev-row-button,
.next-row-button {
  position: absolute;
}

.prev-button {
  left:325px;
  top: 0px;
  width: 300px;
  height: 100%
}

.prev-button:hover {
  cursor: url(../../../backHome/components/cur/left.png), pointer;
}

.next-button {
  right: 10px;
  top: 0;
  width: 300px;
  height: 200%
}

.next-button:hover {
  cursor: url(../../../backHome/components/cur/right.png), pointer;
}

.prev-row-button {
  top: 10px;
  left: 350px;
  width:calc(100% - 400px);
  height: 200px;
}

.prev-row-button:hover {
  cursor: url(../../../backHome/components/cur/top.png), pointer;

}

.next-row-button {
  bottom: 10px;
  left: 350px;
  width: calc(100% - 400px);
  height: 200px;
}

.next-row-button:hover {
  cursor: url(../../../backHome/components/cur/bottom.png), pointer;
}






/deep/.bg_img.el-dialog__header {
  padding: 0px !important;
}

/deep/.bg_img.el-dialog__body {
  padding: 0px !important;
  background: #fff;
}

/deep/.min-x .el-slider__button {
  width: 0px !important;
  height: 0px !important;
  border: 0px solid #409EFF !important;
  background-color: #FFF;
  /* border-radius: 50%; */
  -webkit-transition: .2s;
  transition: .2s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}




@media screen and (min-width: 0px) and (max-width: 1982px) {
  .bg_img_evt {
    height: 750px !important;
    max-width: 1100px;
  }
  /deep/.bg_img.el-table__footer-wrapper {
    position: fixed;
    top: 110px;
    z-index: 111;
    width:100% !important;
  }
}

@media screen and (min-width: 1983px) and (max-width: 2560px) {
  .bg_img_evt {
    height: 900px !important;
    max-width:1550px !important;
  }
    .custom-scrollbar {
      height: 70vh !important;
    }
}

@media screen and (min-width: 2561px) and (max-width: 3440px) {
  .bg_img_evt {
    height: 900px !important;
  }
  .custom-scrollbar{
    height: 70vh !important;
  }
}

@media screen and (min-width: 3441px) and (max-width: 3840px) {
  .bg_img_evt {
    height: 1100px !important;
  }
    .custom-scrollbar {
      height: 70vh !important;
    }
}

.tag_e {
  height: 27px !important;
  line-height: 27px !important
}


// /deep/.class-if-not .el-slider__runway .el-slider__bar {
//   background-color:#409EFF !important;
// }

// /deep/.class-if .el-slider__runway .el-slider__bar {
//   background-color: #979797 !important;

// }
// /deep/.class-if .el-slider__runway .el-slider__button {
//    border: 2px solid #979797 !important
//  }

/deep/.el-table .el-table__cell{
  padding: 5px 0 !important;
}
/deep/.el-table__row .hover-row{
  background-color: #f00 !important;
}
.disabled-row{
  display: block;
}
.enabled-row{
  display: none;
}
//启用
.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell .enabled-row {
  display: block;
}





.custom-scrollbar {
  /* 确保元素可以滚动 */
  overflow-y: scroll;
  /* 或者 overflow-y: auto; 根据需要 */
  -ms-overflow-style: none;
  /* IE 和 Edge */
  scrollbar-width: none;
  /* Firefox */
}

.custom-scrollbar::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}
.custom-scrollbar::-webkit-scrollbar {
  width: 12px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.custom-scrollbar {
  width: 100%;
  scrollbar-color: #888 #f1f1f1;
}
.drag-and-drop-uploader {
  max-width: 250px;
  height:150px;
  text-align: center;
  border: 1px solid #fff;
  border-radius: 5px;
  margin-top: 10px;
}

/deep/.el-collapse-item__content{
  padding-bottom:0px !important;
}
/deep/.el-collapse-item__header{
  height: 35px !important;
}

#myInput::placeholder {
  font-size: 10px;
  /* 设置你希望的字体大小 */
  color: #999;
  /* 可选：设置 placeholder 的颜色 */
}
/deep/.el-table{
  font-size: 12px !important;
}
/deep/.el-table th.el-table__cell>.cell{
  font-size: 12px !important;
}
/deep/.lie_three{
  font-size: 12px !important;
}

/deep/.class-if-not .el-slider__button-wrapper{
  height: 28px !important;
    width: 16px !important;
    z-index: 1001;
    top: -11px !important;
    -webkit-transform: translateX(-0%) !important;
     transform: translateX(-0%) !important;
}
/deep/.class-if .el-slider__button-wrapper {
  z-index: 1001;
  -webkit-transform: translateX(-70%) !important;
  transform: translateX(-70%) !important;
}
 .image-wrapper {
   position: relative;
   overflow: hidden;
  //  background-color: #e5e5e5;
   width: 100%;
   img {
     display: flex;
     /* transition: all .2; */
     width: 100%;
     height: 100%;
     object-fit: contain;
   }
 }


/deep/.vip .el-input__inner {
  background-color: #bcd9f8d4 !important;
  color: #000;
}

#form ::placeholder{
  color: #c4c3c3 !important;
}



.nav-container {
    height: 36px;
    background: #F1F3FD;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border-radius: 10px;
    .button_one{
      width: 195px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      border-radius: 8px;
      cursor: pointer;
      background: #F1F3FD;
    }
    .button {
      width: 130px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      border-radius: 8px;
      cursor: pointer;
      background: #F1F3FD;
      /* 默认背景色 */
    }

    .active_three {
      background: #fff;
      /* 活动状态背景色 */
      color: #000;
      margin: 0 0px;
    }
    .active_one {
      background: #fff;
      /* 活动状态背景色 */
      color: #000;
      margin: 0 5px;
    }
  }


  .all_input {
    margin-top: 10px;
    margin-left: 15px;
    display: flex;
    align-items: center;

  span {
    width: 55px;
    font-size: 11px;
    text-align: end;
    margin-right: 10px;
  }
  .el-dropdown{
    border: 1px solid #858585 !important;
    border-radius: 4px;
  }
  .num_box button{
    border: none;
  }


  .el-input {
    width: 160px;
    height: 40px;
    border-radius: 5px;
  }

  // .el-select {
  //   border: 1px solid;
  //   border-radius: 5px;
  // }

  /deep/.el-input__icon {
    line-height: 30px !important;
    cursor: pointer;
  }
}
.all_input_ect {
  /deep/.el-input__icon {
    line-height: 18px !important;
    cursor: pointer;
    margin-left: -15px !important;
  }
}
/deep/.sousuo .el-input__inner {
  height: 37px !important;
  cursor: pointer;
  border: 1px solid #858585!important;
}
/deep/.sousuo .el-input__inner::placeholder{
  color: #ada8a8!important;
}
/deep/.sousuo .el-dialog__header{
  padding: 0px 20px 10px !important;
}
/deep/.sousuo{
  border-radius: 8px !important;
}

/deep/ .el-input .el-input__clear:hover{
color: #f00 !important;
}
/deep/ .el-date-editor .el-range__close-icon{
color: #f00 !important;
}
/deep/.el-select .el-input .el-icon-circle-close{
  color: #f00 !important;
}
/deep/.el-table th.el-table__cell{
    background: #F5F7FA !important;
    padding: 0 !important;
  }




  /* 默认状态下的样式 */
  /deep/.slow_mot_modified .el-slider__runway {
    height: 2px;
    /* 设置轨道高度 */
    background-color: #ccc !important;
    /* 灰色背景轨道 */
  }

  /deep/.slow_mot_modified .el-slider__bar {
    height: 2px;
    /* 设置轨道高度 */
    background-color: #000 !important;
    /* 灰色背景轨道 */
  }

  /* 滑块按钮默认样式 */
  /deep/.slow_mot_modified .el-slider__button {
    width: 13px;
    height: 13px;
    border: 1px solid #C0C4CC !important;
    margin-left: 3px;
    /* 浅灰色边框 */
  }

  /deep/.slow_mot_modified .el-slider__button-wrapper {
    top: -17px !important;
    /* 调整滑块按钮位置 */
  }


  

  .nav-container_three {
    background: #F1F3FD;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border-radius: 10px;
    font-size: 10px;


    .button_three {
      width: 70px;
      height: 35px;
      text-align: center;
      line-height: 35px;
      border-radius: 8px;
      cursor: pointer;
    }
  }

  .nav-container_one {
    height: 36px;
    background: #F1F3FD;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    border-radius: 10px;
    font-size: 10px;

    .button_one {
      width: 130px;
      height: 34px;
      text-align: center;
      line-height: 35px;
      border-radius: 8px;
      cursor: pointer;
      background-color: #e5e5e5;
      font-weight: 600;
    }
  }



  .active_Free {
    background: #6B98FF !important;
    /* 活动状态背景色 */
    color: #000;
    margin: 0 0px;
    color: #fff;
  }
  
  .meta-item {
    display: flex;
    align-items: center;
    margin-right: 10px;
    /* 可根据需要调整间距 */
    padding: 3px 8px;
    background: #e4e4e4;
    border-radius: 15px;
  }

  .meta-item img {
    width: 11px;
    height: 11px;
    margin-right: 5px;
  }


  .fl_row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }





/* 可点击区域：绝对定位覆盖整个容器，确保空白时也能点击 */
.click-area {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1; /* 确保点击区域在最上层 */
  cursor: pointer; /* 鼠标悬浮时变手型 */
}

/* 备注文字：为空时纯空白，无占位符 */
.remark-text {
  flex: 1;
  color: #333;
  z-index: 2; /* 文字在点击区域上层，不被遮挡 */
  &:empty {
    display: inline-block;
    width: 1px;
    height: 1em;
    visibility: hidden; /* 纯空白，无任何文字 */
  }
}

/* 编辑图标：默认隐藏，hover时显示 */
.edit-icon {
  display: none !important; /* 默认隐藏 */
  color: #409eff;
  font-size: 14px;
  margin-left: 4px;
  z-index: 2; /* 图标在点击区域上层 */
  pointer-events: none; /* 不遮挡点击事件 */
}

/* 悬浮时显示图标 */
.name_box:hover .edit-icon {
  display: inline-block !important; /* hover时强制显示 */
}
</style>
<style>

.your-css-class .el-range-input {
  background-color: #8fc6ff00 !important;
}

.your-css-class_box .el-range-input {
  background-color: #8fc6ff00 !important;
}

.selt {
  color: #909399 !important;
}

::placeholder {
  color: #858585 !important;
}

.border_box {
  border: 1px solid #858585 !important;
  border-radius: 5px
}


</style>



// WEBPACK FOOTER //
// src/AI/components/ai/index.vue